import React, { useState } from "react";
import AlertsModals from "security-app/components/SecurityEvents/Alerts/AlertsModals";
import { ModalProvider } from "common/contexts";
import { Spinner } from "components/common";
import { SegmentedControl } from "components/bootstrap";
import RemediationSteps from "components/events/ReplaySearchSidebar/RemediationSteps";
import useEventsAdditionalData from "components/events/ReplaySearchSidebar/hooks/useEventsAdditionalData";
import ReplaySearchContext from "components/event-definitions/replay-search/ReplaySearchContext";
import EventDefinitionInfoList from "components/event-definitions/replay-search/EventDefinitionInfoList";
import { Tab } from "./EventReplaySideBarDetails";
const EventDefinitionDetails = ({ definitionId, type }) => /* @__PURE__ */ React.createElement(ReplaySearchContext.Provider, { value: { alertId: void 0, definitionId, type } }, /* @__PURE__ */ React.createElement(EventDefinitionInfoList, null));
const segments = [
  { value: "definition", label: "Definition" },
  { value: "procedures", label: "Procedures" }
];
const EventDefinitionSideBarDetails = ({ definitionId }) => {
  const [selectedSegment, setSelectedSegment] = useState("definition");
  const { meta, eventDefinitionEventProcedureId, isLoadingEventDefinition } = useEventsAdditionalData({
    eventData: void 0,
    definitionId
  });
  if (isLoadingEventDefinition) return /* @__PURE__ */ React.createElement(Spinner, null);
  return /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SegmentedControl, { data: segments, value: selectedSegment, onChange: setSelectedSegment }), selectedSegment === "definition" && /* @__PURE__ */ React.createElement(Tab, null, /* @__PURE__ */ React.createElement(EventDefinitionDetails, { definitionId, type: "event" })), selectedSegment === "procedures" && /* @__PURE__ */ React.createElement(Tab, null, /* @__PURE__ */ React.createElement(
    RemediationSteps,
    {
      event: void 0,
      meta,
      eventDefinitionEventProcedureId
    }
  ))), /* @__PURE__ */ React.createElement(AlertsModals, null));
};
export default EventDefinitionSideBarDetails;
